'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');

function interpolateTime(previousPoint,nextPoint,value){
var t1=previousPoint.time.getTime();
var value1=previousPoint.value;
var t2=nextPoint.time.getTime();
var value2=nextPoint.value;

if(value1===value2){
throw new Error('points should not have same values');
}else{
return t1+(t2-t1)*(value-value1)/(value2-value1);
}
}

function _getInterpolatedPoint(previousPoint,nextPoint,value){
let time=interpolateTime(previousPoint,nextPoint,value);
const newPoint={
time:new Date(time),
value:value};

if(previousPoint.notRendered||nextPoint.notRendered){

newPoint.notRendered=!0;
}
return newPoint;
}let

TimeSeries=function(){function TimeSeries(){_classCallCheck(this,TimeSeries)}TimeSeries.
splitAroundThresholdWithInterpolation=function splitAroundThresholdWithInterpolation(timeSeries,threshold){
let top=[];
let bottom=[];

let previousPoint=null;
for(let point of timeSeries){
if(point.value<threshold){
if(_.exists(previousPoint)&&previousPoint.value>threshold){
let interpolatedPoint=_getInterpolatedPoint(previousPoint,point,threshold);
top.push(interpolatedPoint);
bottom.push(interpolatedPoint);
}
top.push({time:point.time,value:NaN});
bottom.push(point);
}else
if(point.value>threshold){
if(_.exists(previousPoint)&&previousPoint.value<threshold){
let interpolatedPoint=_getInterpolatedPoint(previousPoint,point,threshold);
top.push(interpolatedPoint);
bottom.push(interpolatedPoint);
}
top.push(point);
bottom.push({time:point.time,value:NaN});
}else
{
top.push(point);
bottom.push(point);
}
previousPoint=point;
}

return{
top:top,
bottom:bottom};

};TimeSeries.

getInterpolatedPoint=function getInterpolatedPoint(previousPoint,nextPoint,value){
return _getInterpolatedPoint(previousPoint,nextPoint,value);
};TimeSeries.

getInterpolatedPointAtTime=function getInterpolatedPointAtTime(timeSeries,time){
if(_.isEmpty(timeSeries)){
return{time:time,value:NaN};
}

const unixTime=time.getTime();
const bounds={
start:_.first(timeSeries),
end:_.last(timeSeries)};


if(unixTime<=bounds.start.time.getTime()){
return{time:time,value:bounds.start.value};
}
if(unixTime>=bounds.end.time.getTime()){
return{time:time,value:bounds.end.value};
}

let previousPoint=null;
for(let point of timeSeries){
if(point.time.getTime()===unixTime){
return point;
}

if(_.exists(previousPoint)&&previousPoint.time.getTime()<=unixTime&&point.time.getTime()>=unixTime){
const timeDifference=point.time.getTime()-previousPoint.time.getTime();
const fractionBetween=(unixTime-previousPoint.time.getTime())/timeDifference;

const valueDifference=point.value-previousPoint.value;
const interpolatedValue=previousPoint.value+valueDifference*fractionBetween;

return{time:time,value:interpolatedValue};
}

previousPoint=point;
}
};TimeSeries.

assignWhenIntersectingOrOutside=function assignWhenIntersectingOrOutside(timeSeries,intervals,objToAssign){let bounds=arguments.length>3&&arguments[3]!==void 0?arguments[3]:null;
return timeSeries.map(function(tsp){
if(_.exists(bounds)&&!bounds.contains(tsp.time)){
return _.assign({},objToAssign,tsp);
}

for(let interval of intervals){
if(interval.contains(tsp.time)){
return _.assign({},objToAssign,tsp);
}
}

return tsp;
});
};return TimeSeries}();


module.exports=TimeSeries;
//# sourceMappingURL=timeSeries.js.map
